import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import type { ThunkDispatch } from "redux-thunk";

import { editingAccountActions } from "../../reducers/editingAccount";
import StaffNavBar from "../StaffNavBar";
import Toast from "../Toast";

import AccountEditForm from "./AccountEditForm";

interface CurrentUserState {
  is_staff: boolean;
}

function mapStateToProps(state: { currentUser: CurrentUserState }) {
  return { ...state.currentUser };
}

interface AccountEditProps {
  is_staff: boolean;
}

const AccountEdit: React.FC<AccountEditProps> = ({ is_staff }) => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch<ThunkDispatch<unknown, unknown, unknown>>();
  const navigate = useNavigate();

  useEffect(() => {
    if (is_staff && id) {
      dispatch(editingAccountActions.setInitState());
      dispatch(editingAccountActions.setEditingPage("update"));
      dispatch(
        editingAccountActions.getEditAccount({
          id: parseInt(id, 10),
          navigate,
        }),
      );
    }
  }, [is_staff, id, dispatch, navigate]);

  if (!is_staff) return null;
  if (!id) return null;

  return (
    <>
      <Toast />
      <StaffNavBar />
      <AccountEditForm />
    </>
  );
};

export default connect(mapStateToProps)(AccountEdit);
